import Modal from './Modal.js';
import TrashIcon from './TrashIcon.js';
import PresetsIcon from './PresetsIcon.js';
import RefreshIcon from './RefreshIcon.js';
import VersionFooter from './VersionFooter.js';
import { useLanguage } from '../context/LanguageContext.js';
import { usei18n } from '../i18n/i18n.js';
import './OptionsMenu.css';

const OptionsMenu = ({ onRemoveAllData, onConfigurePresets, onClose }) => {
    const { language } = useLanguage();
    const i18n = usei18n(language);

    return (
        <Modal onClose={onClose} onBackdropClick={onClose} id="options-menu">
            <button className="menu-item" onClick={onConfigurePresets}>
                <PresetsIcon width="20" height="20" />
                <span>{i18n('menu.configurePresets')}</span>
            </button>
            <button className="menu-item" onClick={onRemoveAllData}>
                <TrashIcon width="20" height="20" />
                <span>{i18n('menu.removeAllData')}</span>
            </button>
            <button className="menu-item" onClick={() => window.location.reload()}>
                <RefreshIcon width="20" height="20" />
                <span>{i18n('menu.refreshApp')}</span>
            </button>
            <VersionFooter />
        </Modal>
    );
}

export default OptionsMenu;
